import { createSwiper } from '@nulo/swiper';

/**
 * @extends {HTMLElement}
 */
class GivingBackSlider extends HTMLElement {
  /** @type {import('swiper').Swiper | null} */
  #swiper = null;

  connectedCallback() {
    if (this.#swiper) return;

    const swiperEl = this.querySelector('[data-swiper]');
    if (!(swiperEl instanceof HTMLElement)) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount <= 1) return;

    this.#swiper = createSwiper({
      region: this,
      el: swiperEl,
      activeSlideClass: 'swiper-slide-fully-visible',
      config: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        speed: 500,
        watchSlidesProgress: true,
        navigation: {
          nextEl: this.querySelector('.giving-back-slider__nav--next'),
          prevEl: this.querySelector('.giving-back-slider__nav--prev'),
        },
        breakpoints: {
          992: {
            slidesPerView: 1.1,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 1.3,
            spaceBetween: 20,
          },
        },
      },
    });
  }

  disconnectedCallback() {
    this.#swiper?.destroy?.(true, true);
    this.#swiper = null;
  }
}

if (!customElements.get('giving-back-slider')) {
  customElements.define('giving-back-slider', GivingBackSlider);
}
